import {
  iDCardTypesLabel, formatOldCatType,
  isForeign, isCHCard,
} from '@/views/commonConfig/investorConfig';

const occupations = ['党政机关、事业单位', '企业单位', '自由业主', '学生', '军人', '其他', '自定义'];

const mixin = {
  data() {
    return {
      occupations,
      Model: {
        userName: null,
        userSex: null,
        userAge: null,
        catType: '身份证',
        idCardNo: null,
        userCountry: '中国',
        userOccupation: null,
        userPosition: null,
        userLandline: null,
        userMobile: null,
        zip: null,
        userEmail: null,
        userAddress: '',
        documentsValidity: null,
        isValidateForever: false,
      },
      options: {
        scrollToInvalidField: true,
        layout: 'standard',
      },

      fields: [
        {
          type: 'input',
          modelKey: 'userName',
          label: '姓名',
          props: {
            type: 'text',
            disabled: true,
            placeholder: '请输入投资者姓名',
          },
        },
        {
          type: 'input',
          modelKey: 'catType',
          label: '证件类型',
          props: {
            disabled: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'idCardNo',
          label: '证件号码',
          props: {
            type: 'text',
            disabled: true,
            placeholder: '请输入投资者证件号码',
          },
        },
        {
          modelKey: 'documentsValidity',
          label: '证件有效期',
          rules: {
            // required: true,
          },
          messages: {
            required: '请选择证件有效期',
          },
        },
        {
          type: 'checkbox',
          modelKey: 'isValidateForever',
          props: {
            option: {
              label: '若为永久有效，请勾选',
            },
            position: 'right',
          },
          events: {
            input: (value) => {
              console.log(`value = ${value}`, typeof (value));
              if (value === true) {
                this.Model.documentsValidity = '永久有效';
              } else if (value === false) {
                console.log(`value = false, documentsValidity=${this.Model.userCountry}`);
                if (this.Model.documentsValidity === '永久有效') {
                  this.Model.documentsValidity = '';
                }
              }
            },
          },
        },
        {
          type: 'select',
          modelKey: 'userSex',
          label: '性别',
          props: {
            options: ['男', '女'],
            placeholder: '请选择投资者性别',
          },
          rules: {
            required: true,
          },
          messages: {
            required: '请选择投资者性别',
          },
        },
        {
          type: 'input',
          modelKey: 'userAge',
          label: '年龄',
          props: {
            type: 'number',
            placeholder: '请输入投资者年龄',
          },
          rules: {
            required: true,
          },
          messages: {
            required: '请输入投资者年龄',
          },
        },
        {
          type: 'input',
          modelKey: 'userCountry',
          label: '国籍',
          props: {
            disabled: true,
            type: 'text',
          },
        },
        {
          type: 'select',
          modelKey: 'userOccupation',
          label: '职业',
          props: {
            title: '职业',
            options: occupations,
            placeholder: '请输入投资者职业',
          },
          rules: {
            // required: true,
          },
          messages: {
            required: '请输入投资者职业',
          },
        },
        {
          type: 'input',
          modelKey: 'userPosition',
          label: '职务',
          props: {
            type: 'text',
            clearable: true,
            placeholder: '请输入投资者职务',
          },
          rules: {
            // required: true,
            notWhitespace: true,
            custom: val => val && val.length < 21,
          },
          messages: {
            required: '请输入投资者职务',
            custom: '长度在20字符以内',
          },
        },
        {
          type: 'input',
          modelKey: 'userEmail',
          label: '电子邮箱',
          props: {
            type: 'text',
            clearable: true,
            placeholder: 'user@email.com',
          },
          rules: {
            // required: true,
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
          },
          messages: {
            required: '请输入投资者邮箱',
            pattern: '邮箱不合法',
          },
        },
        {
          type: 'input',
          modelKey: 'userLandline',
          label: '座机',
          props: {
            type: 'tel',
            clearable: true,
            maxlength: 20,
            placeholder: '请输入座机号码',
          },
          rules: {
            // required: true,
            notWhitespace: true,
            pattern: /\d{1,20}/,
          },
          messages: {
            required: '请输入座机号码',
            pattern: '座机不合法',
          },
        },
        {
          type: 'input',
          modelKey: 'userMobile',
          label: '手机',
          props: {
            type: 'number',
            // disabled: true,
            placeholder: '请输入手机号码',
          },
        },
        {
          type: 'input',
          modelKey: 'zip',
          label: '邮编',
          props: {
            type: 'number',
            clearable: true,
            placeholder: '请输入邮编',
          },
          rules: {
            // required: true,
            notWhitespace: true,
            pattern: /^[0-9]{6}$/,
          },
          messages: {
            required: '请输入邮编',
            pattern: '邮编不合法',
          },
        },
        {
          type: 'textarea',
          modelKey: 'userAddress',
          label: '住址',
          props: {
            maxlength: 100,
            indicator: false,
            placeholder: '请输入住址',
          },
          rules: {
            // required: true,
            notWhitespace: true,
            custom: val => val && val.length < 100,
          },
          messages: {
            required: '请输入住址',
            custom: '长度在100字符以内',
          },
        },
        {
          type: 'submit',
          label: '确认',
        },
        {
          type: 'input',
          modelKey: 'customUserOccupation',
          props: {
            maxlength: 30,
            indicator: false,
            placeholder: '请输入您的职业',
          },
          rules: {
            required: true,
            notWhitespace: true,
            custom: val => val && val.length < 30,
          },
          messages: {
            required: '请输入住址',
            custom: '长度在30字符以内',
          },
        },
      ],
    };
  },
  watch: {
    'Model.isValidateForever': {
      handler(val) {
        if (val) {
          this.Model.documentsValidity = '永久有效';
        }
      },
      immediate: false,
    },
  },
  methods: {
    // 获取证件类型名称
    $_iDCardTypesLabel: iDCardTypesLabel,
    // 老数据处理
    $_formatOldCatType: formatOldCatType,
    // 判断是否显示国籍
    $_isForeign: isForeign,
    /**
     * 通过身份证号码计算性别和年龄
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    $_getAgeAndSex(val) {
      if (val && val.length === 18 && isCHCard(this.Model.catType)) {
        const strBirthday = `${val.substr(6, 4)}/${val.substr(10, 2)}/${val.substr(12, 2)}`;
        const birthDate = new Date(strBirthday);
        const nowDateTime = new Date();
        let age = nowDateTime.getFullYear() - birthDate.getFullYear();
        if (nowDateTime.getMonth() < birthDate.getMonth()
        || (nowDateTime.getMonth() === birthDate.getMonth()
        && nowDateTime.getDate() < birthDate.getDate())) {
          age -= 1;
        }
        const Sex = Number(val.substring(16, 17));

        this.Model.userAge = age;
        this.Model.userSex = Sex % 2 === 0 ? '女' : '男';
      } else {
        // this.Model.userAge = null;
        // this.Model.userSex = null;
      }
    },
    /**
     * 选择证件有效期
     * @return {[type]} [description]
     */
    $_handleShowOrgDocumentsValidityPicker() {
      if (this.Model.isManagerValidateForever) return;
      this.$createDatePicker({
        title: '证件有效期',
        min: new Date(1999, 12, 1),
        max: new Date(2099, 11, 31),
        format: {
          year: 'YYYY',
          month: 'MM',
          date: 'DD',
        },
        value:
          this.Model.documentsValidity
            ? new Date(this.Model.documentsValidity)
            : new Date(),
        onSelect: (date, selectedVal, selectedText) => {
          this.$set(this.Model, 'documentsValidity', selectedText.join('-'));
          this.$set(this.Model, 'isValidateForever', false);
        },
        onCancel: () => {
        },
      }).show();
    },
  },
};
export default mixin;
